var map = {
	"./001_storesace/logo.png": "7035",
	"./002_jeronymo/logo.png": "a040",
	"./003_hussel/logo.png": "d326",
	"./004_frangovaidoso/logo.png": "0916",
	"./005_ola/logo.png": "94e5",
	"./006_maissabor/logo.png": "3634",
	"./008_cacula/logo.png": "98d5",
	"./009_carpediem/logo.png": "7e8e",
	"./010_degema/logo.png": "dc9b",
	"./011_wowfoods/logo.png": "5cdd",
	"./012_myfood/logo.png": "04d3a",
	"./013_subway/logo.png": "6111",
	"./014_portelacafes/logo.png": "4610",
	"./015_madpizza/logo.png": "7d09",
	"./016_tiger/logo.png": "bdda",
	"./017_sushirao/logo.png": "d4bd",
	"./018_stonebystone/logo.png": "53a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "faab";